import DetailTrendPointChartField from './fields/Detail/TrendPointChartField.vue'

const trendPointChartFieldSetup = (app) => {
  app.component('detail-trend-point-chart-field', DetailTrendPointChartField)
  // Nova still resolves form/index components — provide empty shells.
  app.component('form-trend-point-chart-field', { render: () => null })
  app.component('index-trend-point-chart-field', { render: () => null })
}

export { trendPointChartFieldSetup }
